import { AbstractControl, ValidatorFn } from '@angular/forms';
import moment from 'moment';

export const DateFormatValidator = (): ValidatorFn =>
  (control: AbstractControl): { [key: string]: any } | null => {
    const date = moment(control.value, 'YYYY/MM/DD', true);
    return !date.isValid() ? { dateError: true } : null;
  };
